import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import global_en from "./translations/en/global.json";
import global_it from "./translations/it/global.json";
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { MenuProvider } from './contexts/MenuContext';
import { AuthProvider } from './contexts/AuthProvider';

// Disabilita MetaMask se presente (non serve per questa app)
if (window.ethereum) {
  console.log('MetaMask rilevato ma non utilizzato da questa applicazione');
}

// Filtra gli errori di MetaMask dalla console e dagli errori runtime
const originalError = console.error;
console.error = (...args) => {
  const errorString = args[0]?.toString?.() || '';
  if (
    errorString.includes('MetaMask') || 
    errorString.includes('chrome-extension://nkbihfbeogaeaoehlefnkodbefgpgknn') ||
    args[0]?.message?.includes?.('MetaMask')
  ) {
    // Ignora errori MetaMask
    return;
  }
  originalError.apply(console, args);
};

// Intercetta gli errori non gestiti per filtrare MetaMask
window.addEventListener('error', (event) => {
  if (
    event.message?.includes('MetaMask') ||
    event.filename?.includes('chrome-extension://nkbihfbeogaeaoehlefnkodbefgpgknn')
  ) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
});

// Intercetta le promise rejection per filtrare MetaMask
window.addEventListener('unhandledrejection', (event) => {
  if (
    event.reason?.message?.includes('MetaMask') ||
    event.reason?.toString?.().includes('MetaMask')
  ) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
});

i18next.init({
  interpolation: {escapeValue: false},
  lng:"it",
  resources:{
    en:{
      global: global_en
    },
    it:{
      global: global_it
    }
  }
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>

    <MenuProvider>

    <I18nextProvider i18n={i18next}>

      <App />
    </I18nextProvider>
    </MenuProvider>
  </AuthProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
